import { zoneHeightMapping } from '@/utils/ads/zones';
import type { Breakpoint, contentStats } from 'tempest-common';
import {
	type Zone,
	SmartSlots,
	type SmartSlotsDeps,
	type SmartSlotConfig,
} from '@themaven-net/smart-slots';

// if sidebars are enabled, then additional sizes are considered - 970x90, 970x250 for breakpoints C, D

export const applySmartSlots = (
	html: string,
	cs: contentStats.ContentStats,
	contentItem: SmartSlotsDeps['contentItem'],
	{ useFallbackVideo = false },
	smartSlotConfig: SmartSlotConfig,
) => {
	/**
	 * Setup SmartSlots for this page.
	 */

	const updatedSmartSlotConfig = { ...smartSlotConfig };

	// Special handling for the FallbackVideo widget... page context can
	// drive whether the fallback video is to be shown; for instance, if
	// we are rendering the 2nd or later post for continuous scroll, we
	// will not show it since it has already rendered for the page.
	// This could be handled via rules, if the rules had access to the
	// post index being rendered.
	if (updatedSmartSlotConfig?.widgets?.FallbackVideo?.config?.isActive) {
		if (useFallbackVideo) {
			updatedSmartSlotConfig.slots = {
				// Unless otherwise configured, specify a configuration for
				// the first slot on the page, so that it will provide a
				// FallbackVideo widget, alongside an in-content ad.
				'0': {
					widgets: ['FallbackVideo', 'InContentAd'],
				},
				...(updatedSmartSlotConfig.slots ?? {}),
			};
		}
		updatedSmartSlotConfig.widgets.FallbackVideo.config.isActive =
			useFallbackVideo;
	}

	const smartSlots = new SmartSlots(
		{
			contentItem,
			contentStats: cs,
			enabled: true,
			markup: html,
		},
		updatedSmartSlotConfig,
	);

	return smartSlots.processMarkup();
};

export const getReservedHeightForVariant = (
	breakpoint: Breakpoint | null,
	smartSlotConfig: SmartSlotConfig,
	variant: string,
) => {
	const adWidget = smartSlotConfig?.widgets?.[variant];

	switch (adWidget.widgetType) {
		case 'Ad': {
			const height =
				zoneHeightMapping[adWidget.config.zone as Zone]?.[breakpoint ?? 'D'];
			return height;
		}
		// TODO: handle other widget types if needed
		default:
			return 0;
	}
};
